/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import * as React from 'react';
import ReactDOM from 'react-dom';

export const PortalModal = ({ children }: { children: React.ReactNode }) =>
    ReactDOM.createPortal(React.Children.only(children), document.querySelector('#modal'));
